import { useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import AssetDetail from './training-education-component/AssetDetail';
import ContinuousEductionDetail from './training-education-component/ContinuousEductionDetail';
import EmployeeExpensesDetail from './training-education-component/EmployeeExpensesDetail';

/*--------------------------------Accordion-------------------------------------*/

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

/*------------------------------------------------------------------------------------*/
const TrainingEduction = ({personalInfo,setSnackState ,setSuccessMsg}) => {
  const [expanded, setExpanded] = useState('panel1');

  const handleChangePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>Training & Continuous Education</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ContinuousEductionDetail personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg}/>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChangePanel('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>Asset Information (need to provide a link to LPO MGT)</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AssetDetail personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg}/>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChangePanel('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Employee Expenses</Typography>
        </AccordionSummary>
        <AccordionDetails>
         <EmployeeExpensesDetail personalInfo={personalInfo} setSnackState={setSnackState} setSuccessMsg={setSuccessMsg}/>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default TrainingEduction